<div class="crud-icon" [ngClass]="icon_class"></div>